interface LmsTitleDescriptionFieldsProps {
  title: string;
  onTitleChange: (value: string) => void;
  titlePlaceholder: string;
  description: string;
  onDescriptionChange: (value: string) => void;
  descriptionPlaceholder: string;
  descriptionRows?: number;
}

export default function LmsTitleDescriptionFields({
  title,
  onTitleChange,
  titlePlaceholder,
  description,
  onDescriptionChange,
  descriptionPlaceholder,
  descriptionRows = 3,
}: LmsTitleDescriptionFieldsProps) {
  return (
    <>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">
          Title <span className="text-red-500">*</span>
        </label>
        <input
          type="text"
          value={title}
          onChange={(e) => onTitleChange(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500"
          placeholder={titlePlaceholder}
        />
      </div>

      <div>
        <label className="block text-sm font-medium text-gray-700 mb-1">Description</label>
        <textarea
          value={description}
          onChange={(e) => onDescriptionChange(e.target.value)}
          className="w-full px-3 py-2 text-sm border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary-500 resize-none"
          rows={descriptionRows}
          placeholder={descriptionPlaceholder}
        />
      </div>
    </>
  );
}
